import React from 'react';
import { Link } from 'react-router-dom';
import useGlobalContext from '../../hooks/useGlobalContext';

const HomeHeroSingleSlide = ({ bg_className}) => {
   const videoPopup = useGlobalContext();
   const {setIsOpen} = videoPopup
   return (
      <>
         <div className={`single-slider slider-height d-flex align-items-center slider_bg_${bg_className}`}>
            <div className="container">
               <div className="row">
                  <div className="col-xl-6 col-lg-8 col-md-10">
                     <div className="hero-text">
                        <div className="hero-slider-caption ">
                           <h5>We are here for your care.</h5>
                           <h1>Assurance:</h1>
                           <h1>Your Home</h1>
                           <h1>Care Experts</h1>
                           <p>Choose Assurance for a partner that brings expertise, empathy, and excellence to the heart of your home, every single day.

                              Peace of Mind. Guaranteed.

                           </p>
                        </div>
                        <div className="hero-slider-btn">
                           <Link to="/contact" className="primary_btn btn-icon ml-0"><span>+</span>Make Appointment</Link>

                           {/*<button onClick={() => setIsOpen(true)}*/}
                           {/*   className="play-btn popup-video"><i className="fas fa-play"></i></button>*/}

                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </>
   );
};

export default HomeHeroSingleSlide;